import { render, staticRenderFns } from "./bcard.vue?vue&type=template&id=386e4850&scoped=true&"
import script from "./bcard.vue?vue&type=script&lang=js&"
export * from "./bcard.vue?vue&type=script&lang=js&"
import style0 from "./bcard.vue?vue&type=style&index=0&id=386e4850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e4850",
  null
  
)

export default component.exports